import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            快速导航分类
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            按需选择分类，快速找到您需要的 91n.com 相关内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 transition-all group cursor-pointer flex flex-col items-center text-center"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-full ${
                cat.color === 'primary' ? 'bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50' :
                cat.color === 'accent' ? 'bg-accent-50 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50' :
                'bg-secondary-50 text-secondary-500 group-hover:bg-secondary-500 group-hover:text-background-50'
              } transition-colors`}>
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-950 whitespace-nowrap">{cat.name}</h3>
              <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}